import { Injectable, inject } from '@angular/core';
import {LorenLayerEndpointsService} from './services/loren-layer-endpoints-service/loren-layer-endpoints.service';
import {LorenLayer} from './interfaces/loren-layer.interface';
import {GenericItems} from '../../interfaces/generic-items.interface';
import {LorenLayerItem} from './interfaces/loren-layer-item.interface';
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class LorenLayerService {
    private endpointsService = inject(LorenLayerEndpointsService);
    private http = inject(HttpClient);


    getAllLayers() {
        return this.http.get<GenericItems<LorenLayer>>(this.endpointsService.getLayers(), {});
    }

    getLayerItems(layerId: number, neLat: number, neLng: number, seLat: number, seLng: number, zoomLevel: number) {
        return this.http.get<LorenLayerItem>(this.endpointsService.getLayerItems(layerId, neLat, neLng, seLat, seLng, zoomLevel), {});
    }
}
